import Swal from "sweetalert2";

export const showSuccessDialog = (message) =>
  Swal.fire({
    title: "Success",
    text: message,
    icon: "success",
    confirmButtonText: "OK",
    allowOutsideClick: () => {},
  });

export const showErrorDialog = (message) =>
  Swal.fire({
    title: "Error",
    text: message,
    icon: "error",
    confirmButtonText: "OK",
  });

export const showDialog = (
  message,
  title = "Info",
  icon = "info",
  confirmText = "OK"
) =>
  Swal.fire({
    title: title,
    text: message,
    icon: icon,
    confirmButtonText: confirmText,
    allowOutsideClick: () => {},
  });

export const showDialogHtml = (
  message,
  title = "Info",
  icon = "info",
  confirmText = "OK"
) =>
  Swal.fire({
    title: title,
    html: message,
    icon: icon,
    confirmButtonText: confirmText,
    allowOutsideClick: () => {},
  });

export const showConfirmDialog = (message) =>
  Swal.fire({
    title: "Confirm",
    html: message,
    icon: "info",
    showCancelButton: true,
    confirmButtonColor: "primary",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    allowOutsideClick: () => {},
  });

export const showDeleteDialog = (message) =>
  Swal.fire({
    title: "Delete",
    html: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "red",
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
    allowOutsideClick: () => {},
  });

export const Toast = (message) => {
  return Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  }).fire({
    icon: "info",
    title: message.title,
    text: message.body, // Change the message body here
  });
};
